export interface MirrorBetPayload {
  amount: number;
  autoCashout?: number;
  slotId?: 1 | 2;
  autoPlace?: boolean;
}

export function useMirrorBet() {
  const mirrorBet = (payload: MirrorBetPayload) => {
    if (typeof window === 'undefined') return;
    const event = new CustomEvent('memePump:mirrorBet', { detail: payload });
    window.dispatchEvent(event);
  };

  return { mirrorBet };
}
